module.exports = __webpack_public_path__ + "img/County-Clean.ed04d4aa.jpg";